import { store } from "@app/store";
import { Button } from "@components/button";
import { EllipsisText } from "@components/ellipsis-text";
import { FlexLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { RowTable } from "@components/row-table";
import { Config, DoubleText } from "@components/table";
// import {
//   PaymentCredited,
//   PaymentNotCredited,
//   PaymentProcessing,
// } from "@features/appeals/components/status";
import { usePayoutOrders } from "@features/payouts";
import { OrderPayout } from "@features/payouts/api";
import {
  removeFile,
  resetOrder,
  setMessage,
  setReceipts,
} from "@features/payouts/slice";
import { formatDate, formatTime } from "@helpers/date";
import { formatRubles, formatUsdt } from "@helpers/format";
import { useNotification } from "@hooks/use-notification";
import { useEffect } from "react";

type Props = {
  isOpen: boolean;
  hide: () => void;
  data: OrderPayout;
};

export const PayOutCancelModal = ({ isOpen, hide, data }: Props) => {
  const { state, uploadReceipt, cancelPayOutOrder, getPayoutOrders } =
    usePayoutOrders();
  const notif = useNotification();

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files == null || data.id == null) return;
    const file = event.target.files;
    uploadReceipt(data.id, file).then(() => {
      notif.addNotification("Файл добавлен");
    });
  };
  useEffect(() => {
    store.dispatch(resetOrder());
    if (data.trader_files) store.dispatch(setReceipts(data.trader_files));
  }, [data]);

  const config: Config<OrderPayout> = [
    {
      label: "Номер заявки",
      source: "id",
      renderComponent: (data) => <EllipsisText text={data} copy />,
    },
    {
      label: "Дата",
      source: "created_at_unix",
      renderComponent: (data) => (
        <div>
          {formatDate(new Date(data * 1000))}{" "}
          {formatTime(new Date(data * 1000))}
        </div>
      ),
    },
    {
      label: "Сумма",
      source: "sum",
      renderComponent: (data, item) => (
        <DoubleText
          text={formatRubles(data)}
          subText={formatUsdt(item.sum_usdt)}
        />
      ),
    },
    {
      label: "Файлы",
      source: "id",
      renderComponent: () => {
        return (
          <>
            {state.isReceiptLoading ? (
              "Загрузка..."
            ) : (
              <>
                {state.receiptUrls.map((file) => (
                  <div
                    key={file}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                  >
                    <a className="underline" href={file} target="_blank">
                      {file.split("/").pop()}
                    </a>
                    <span
                      style={{ color: "red" }}
                      onClick={() => {
                        store.dispatch(removeFile(file));
                      }}
                    >
                      ×
                    </span>
                  </div>
                ))}

                <label style={{ cursor: "pointer" }}>
                  Добавить
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </label>
              </>
            )}
          </>
        );
      },
    },
    {
      label: "Сообщение",
      source: "id",
      renderComponent: () => (
        <textarea
          value={state.message}
          onChange={(e) => store.dispatch(setMessage(e.target.value))}
        ></textarea>
      ),
    },
  ];
  const sendOrderData = async () => {
    if (state.message.length == 0) {
      notif.addNotification("Сообщение не должно быть пустым!");
      return;
    }
    const request = {
      images: state.receiptUrls,
      order: data.id,
      comment: state.message,
    };
    cancelPayOutOrder(data.id, request).then(() => {
      hide();
      notif.addNotification("Создано!");
      getPayoutOrders({ limit: 100, page: 1, my_orders: true });
    });
  };
  return (
    <Modal isOpen={isOpen} onClose={hide} title={`❌ Заявка №${data.id}`}>
      <p>Отмена заявки на вывод</p>
      {state.isReviewLoading ? (
        <FlexLoader style={{ width: "200px", height: "200px" }} />
      ) : (
        <RowTable config={config} data={data} />
      )}
      <Button onClick={() => sendOrderData()} type="danger">Отменить заявку</Button>
    </Modal>
  );
};
